export default "__VITE_ASSET__zVR3I5Vb__"